import { useEffect, useState } from 'react';
import { useAuth } from 'context/AuthContext';
import { getExtrato } from 'services/realization.service';

/**
 * Indica se o usuário logado ganhou prêmio (tem extrato com valor).
 * Sinal: `getExtrato` retorna `totais.bruto > 0` apenas para ganhadores.
 * Usado para ocultar o extrato, o popup da home e o flag do header.
 */
export function useGanhouPremio(): { ganhou: boolean; loading: boolean } {
  const { user } = useAuth();
  const [ganhou, setGanhou] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let ativo = true;

    if (!user?._id) {
      setGanhou(false);
      setLoading(false);
      return;
    }

    setLoading(true);
    getExtrato(user._id)
      .then((res) => {
        if (ativo) setGanhou(res.totais.bruto > 0);
      })
      .catch(() => {
        if (ativo) setGanhou(false);
      })
      .finally(() => {
        if (ativo) setLoading(false);
      });

    return () => {
      ativo = false;
    };
  }, [user?._id]);

  return { ganhou, loading };
}
